import Axios from "axios";
import { authorizedAxios } from "../../../Actions/AxiosActions";
import { RetailMatchGeographyOption } from "../../../Enums/RetailMatchGeographyOption";
import { IRetailMatchJob } from "../../../Models/IRetailMatch";
import { IRetailMatchGeography } from "../../../Models/IRetailMatchGeography";
import { IServiceResult } from "../../../Models/IServiceResult";
import { ISubmitRetailMatchJobRequest } from "../../../Models/Requests/ISubmitRetailMatchJobRequest";

export async function getRetailMatchGeographies(option: RetailMatchGeographyOption): Promise<IRetailMatchGeography> {
    /** purposefully unauthorized */
    const response = await Axios.get<IServiceResult<IRetailMatchGeography>>(
        `/Common/GetRetailMatchGeographies?level=${option}`
    );
    return response.data.data;
}

export async function submitMatchReport(request: ISubmitRetailMatchJobRequest): Promise<IRetailMatchJob> {
    return await authorizedAxios<IRetailMatchJob>("POST", "/services/gps/RetailMatch/submit", null, request);
}

export async function siteIsInDMA(latitude: number, longitude: number): Promise<boolean> {
    return await authorizedAxios<boolean>("GET", `/services/gps/RetailMatch/SiteIsInDMA/${latitude}/${longitude}`);
}